import { Body3 } from '@flatsy/core/MaterialUi/Typo'
import FlatsyTheme from '@flatsy/core/MuiTheme/flatsyTheme'
import React from 'react'
import useStyle from './Style'

const Validated: React.FC = () => {
  const classes = useStyle()
  return (
    <div className={classes.container}>
      <img
        className={classes.illu}
        src={FlatsyTheme.image.uploadValidated}
        alt="Dossier individuel validé"
      />
      <Body3 className={classes.title}>Dossier individuel validé</Body3>
    </div>
  )
}

export default Validated
